import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WithheldTaxReportSummary  {
    _originalTypeClassName = "zERP.BO.WithheldTaxReportSummary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WithheldTaxReportSummary.translate = translateService;
}
this.Id = null;
this.GrossAmount = null;
this.DeductionsAmount = null;
this.TaxAmount = null;
this.StampDutyAmount = null;
this.NetAmount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
GrossAmount:any;
DeductionsAmount:any;
TaxAmount:any;
StampDutyAmount:any;
NetAmount:any;
AADECode:any;
static setAADECode = ($this, value) => {
var oldValue = $this.AADECode;
$this.AADECode = value;
if (value != null) {
}
}

static Calculate(invoice: any): any{let summary = new Domain.WithheldTaxReportSummary();
let taxes = invoice?.TaxesTotals;
if (CLMS.Framework.Number.Equal(() => taxes.length, () => 0)) {return null;}
let firstAvailableTax = invoice?.TaxesTotals?.linq?.where((l) => l?.Tax != null && l?.Tax?.AADECode != null)?.firstOrDefault(null)?.Tax;
if (firstAvailableTax != null) {for (let _itax = 0; _itax < (taxes == null ? 0 : taxes.length); _itax++) {let tax = taxes[_itax];if (tax?.Tax?.AADECode?.Code != firstAvailableTax?.AADECode?.Code && tax?.Tax?.AADECode != null) {throw Error("Cannot have more than one AADE code for tax on invoice...");}}}
Domain.WithheldTaxReportSummary.setAADECode(summary, firstAvailableTax?.AADECode);
summary.GrossAmount = invoice?.InvoiceSummary?.TotalGrossValue;
summary.DeductionsAmount = invoice?.InvoiceSummary?.TotalWithheldAmount;
summary.TaxAmount = Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalVatAmount) + Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalTaxesAmount) - Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalStampDutyAmount);
summary.StampDutyAmount = invoice?.InvoiceSummary?.TotalStampDutyAmount;
summary.NetAmount = invoice?.InvoiceSummary?.TotalNetValue;
return summary;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}